module.exports = __webpack_public_path__ + "static/media/student-photo-prev.c65dfa99.png";